<div class="view-content">
  @if (success) {
    <div class="view-section success">
      <app-animated-check></app-animated-check>
      <p>{{ 'jobboard.views.unsubscribe-kira-mail-chat.success' | transloco }}</p>
    </div>
  }
</div>
